<template>
  <div
    style="position:relative;height:100%;"
  >
    <div
        style="padding: 25px;text-align:left;z-index:4;border-bottom: 1px solid rgba(0,0,0,0.1);background:white;padding-top: var(--mobile-padding-top, 25px);"
    >
        <h1>
            My Cases
        </h1>
        <span style="font-weight: normal;">Your active cases</span>
        <v-btn
            v-if="getDomainInfo && getDomainInfo.info && getDomainInfo.info.cases && $vuetify.breakpoint.smAndDown"
            fab
            color="primary"
            @click="infoDialog = true"
            style="position:absolute;right:20px;top: 20px;"
        >
            <v-icon>
                mdi-help
            </v-icon>
        </v-btn>
    </div>
    <div
        :class="{ 'mobile-content': $vuetify.breakpoint.xs, 'flex-col': $vuetify.breakpoint.smAndDown}"
        style="padding: 25px;display: flex;"
    >
        <div
            style="flex-grow: 1;"
        >
            <v-layout
                v-if="cases.length > 0"
                row
                wrap
            >
                <v-flex
                    v-for="xcase in cases"
                    :key="xcase.id"
                    xs12
                    sm12
                    md12
                    lg6
                    xl4
                    class="standard-form-card"
                    :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                >
                    <v-card    
                        class="form-card"
                        style="cursor:pointer;"
                        @click="$router.push({ name: 'Forms', params: { id: xcase.id } })"
                    >
                        <div
                            style="display:flex;align-items: center;"
                        >
                            <div>
                                <img
                                    :src="getIconPath(xcase.case_type.id)"
                                    style="aspect-ratio: 1/1; max-height: 65px;margin: 10px;"
                                />
                            </div>
                            <div
                                style="flex-grow: 1;"
                            >
                                <div
                                    style="font-size: 16px;font-weight: bold;"
                                >
                                    {{xcase.case_type.name}}
                                </div>
                                <br />
                                <span
                                    v-if="xcase.case_number"
                                    style="font-weight: bold;"
                                >
                                    {{xcase.case_number}}
                                </span>
                                <span
                                    v-if="xcase.case_title"
                                    style="font-style: italic;"
                                >
                                    ({{xcase.case_title}})
                                </span>
                            </div>
                        </div>
                    </v-card>
                </v-flex>
            </v-layout>
            <div
                v-if="cases.length == 0"
            >
                <div
                    class="last-message"
                    style="position:relative;margin:auto;margin-top:100px;font-size:24px;vertical-align:middle;text-align:center;opacity:1;z-index:0;border-radius: 50%;width:300px;height:300px;"
                >
                    <div
                        style="position:absolute;top:50px;text-align:center;width:100%;"
                    >
                        <v-icon
                            color="262626"
                            size="72"
                        >
                            mdi-briefcase-outline
                        </v-icon>
                        <br />
                        <span><br /><b>You have no cases</b></span>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="getDomainInfo && getDomainInfo.info && getDomainInfo.info.cases && $vuetify.breakpoint.mdAndUp"
            class="cases-info"
        >
            <div
                v-html="getDomainInfo.info.cases"
            />
        </div>
    </div>
    <v-dialog
        v-model="infoDialog"
        width="500"
    >
        <v-card>
            <v-card-text
                v-html="getDomainInfo && getDomainInfo.info && getDomainInfo.info.cases ? getDomainInfo.info.cases : ''"
                style="max-height: 50vh;overflow-y: auto"
            />
            <v-card-actions
                style="background: #E0E0E0;"
            >
                <v-spacer />
                <v-btn
                    @click="infoDialog = false"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3

export default {
    name: 'Cases',
    data () {
        return {
            cases: [],
            infoDialog: false,
            loading: false
        }
    },
    created () {
        this.fetchForms()
    },
    methods: {
        fetchForms () {
            this.loading = true
            api.userform.contactCases.list({ count: 50 })
                .then(data => {
                    this.cases = data.results
                })
        },
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
    }
}
</script>

<style scoped>
    .standard-content {
        max-height: calc(100vh - 93px);
        height:100%;
        overflow-y:auto;
        position: relative;
    }
    .mobile-content {
        height:100vh;
        max-height: calc(100vh - 93px - 56px - var(--mobile-padding-top) - var(--mobile-padding-bottom)) !important;
        position: relative;
    }

    .form-card {
        position: relative;
    }

    .standard-form-card {
        padding-right: 15px;
        padding-top: 15px;
    }

    .mobile-form-card {
        padding-top: 15px;
        padding-right: 0 !important;
    }

    .flex-col {
        flex-direction: column;
    }

    .cases-info {
        max-width: 400px;
        width: 100%;
        height: auto;
        padding: 20px;
        background: white;
    }

    .flex-col .cases-info {
        max-width: 100% !important;
    }
</style>